import { render, staticRenderFns } from "./LoadingChart.vue?vue&type=template&id=8e10cbb4&scoped=true"
import script from "./LoadingChart.vue?vue&type=script&lang=js"
export * from "./LoadingChart.vue?vue&type=script&lang=js"
import style0 from "./LoadingChart.vue?vue&type=style&index=0&id=8e10cbb4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e10cbb4",
  null
  
)

export default component.exports